// extracted by mini-css-extract-plugin
module.exports = {"tableWrap":"EnrolledClinics_tableWrap__29cWZ","actionsCol":"EnrolledClinics_actionsCol__1Cbjk"};